import * as actionTypes from "../action-types";

const initialState = {
    isLoading: true,
    isScreenScroll: false,
};

const commonReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_IS_LOADING:
            return { ...state, isLoading: payload };

        case actionTypes.SET_SCREEN_SCROLL:
            return { ...state, isScreenScroll: payload };

        default:
            return state;
    }
};

export default commonReducer;